/* eslint-disable linebreak-style */
import React from 'react';
const PropertyDamageStepShared = () => (
  <ol>
    <li>
    A copy of police report filed by the guest for theft claims.
    </li>
    <li>
    Photographs of the property damage.
    </li>
    <li>
    The repair paid invoices or original purchase receipt (when available) and replacement receipt.
    </li>
  </ol>
);

export default PropertyDamageStepShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PropertyDamageStep/components/PropertyDamageStepShared.js